import React, { useState, useEffect, useRef } from "react";
import "./About.css";
import Popup from "../components/popup.js";
import { Client, Databases, ID } from "appwrite";
import recright from "../assets/Home/recright.webp";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import aireadiness from "../assets/Home/secondpic.png";
import fortunecookie from "../assets/Home/home1.webp";
import knowledgenudge from "../assets/Home/workspace.webp";
import functional from "../assets/Home/FUNCTIONAL AI.jpg";
import textual from "../assets/Home/textual.png";
import analytical from "../assets/Home/Analytical AI.png";
import visualai from "../assets/Home/Visual AI.png";
import chateleon from "../assets/Home/chateleon.png";
import { ChevronLeft, ChevronRight } from "lucide-react";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import config from "../config/config";
import { useLocation } from "react-router-dom";

// Inside your about-us component:

const Platform = ({ utmContent }) => {
  useEffect(() => {
    // Set page title
    document.title = "Platform | Random Walk";

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation.";
      document.head.appendChild(meta);
    }

    // Add or update Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute("content", "Platform | Random Walk");

    // Add or update Open Graph description
    let ogDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (!ogDescription) {
      ogDescription = document.createElement("meta");
      ogDescription.setAttribute("property", "og:description");
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute(
      "content",
      "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation."
    );

    // Add viewport meta tag
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.head.appendChild(viewport);
    }
    viewport.setAttribute("content", "width=device-width, initial-scale=1");

    // Add theme-color meta tag
    let themeColor = document.querySelector('meta[name="theme-color"]');
    if (!themeColor) {
      themeColor = document.createElement("meta");
      themeColor.name = "theme-color";
      document.head.appendChild(themeColor);
    }
    themeColor.setAttribute("content", "#000000");

    // Add Open Graph image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement("meta");
      ogImage.setAttribute("property", "og:image");
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute("content", `${process.env.PUBLIC_URL}/rw_logo.png`);

    // Add Open Graph type
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement("meta");
      ogType.setAttribute("property", "og:type");
      document.head.appendChild(ogType);
    }
    ogType.setAttribute("content", "website");

    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = "https://randomwalk.ai/platform/";
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessemail, setEmailId] = useState("");
  const [projectdetails, setprojectdetails] = useState("");

  const [utmParams, setUtmParams] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_id: "",
    utm_term: "",
    utm_content: "",
  });
  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setfirstname("");
    setlastname("");
    setPhoneNumber("");
    setCompanyName("");
    setEmailId("");
    setprojectdetails("");
    setIsChecked(true);
    setErrors({});
  };
  const handleButtonClickcontact = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  const handlePhoneNumberChange = (number, country) => {
    setPhoneNumber(number);

    try {
      // Ensure number starts with +
      const fullNumber = number.startsWith("+") ? number : `+${number}`;

      // Check if the number is valid for the selected country
      if (isValidPhoneNumber(fullNumber)) {
        const phoneNumberObj = parsePhoneNumberFromString(fullNumber);
        const nationalNumber = phoneNumberObj.nationalNumber;

        // Get expected length based on country
        const expectedLength = phoneNumberObj.nationalNumber?.length;
        const actualLength = nationalNumber?.length;

        if (actualLength < expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too short - needs ${expectedLength} digits`,
          }));
        } else if (actualLength > expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too long - should be ${expectedLength} digits`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setErrors((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid phone number",
      }));
    }
  };

  // useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);

  //   setUtmSource(searchParams.get("utm_source") || "");
  //   setUtmMedium(searchParams.get("utm_medium") || "");
  //   setUtmCampaign(searchParams.get("utm_campaign") || "");
  //   setUtmId(searchParams.get("utm_id") || "");
  //   setUtmTerm(searchParams.get("utm_term") || "");
  //   setUtmContent(searchParams.get("utm_content") || "");
  // }, []);

  useEffect(() => {
    const captureUtmParams = () => {
      console.log(utmContent);
      const params = new URLSearchParams(window.location.search);
      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
      ];

      const newUtmParams = {
        utm_content: utmContent,
      };
      utmFields.forEach((field) => {
        newUtmParams[field] = params.get(field) || "";
      });
      console.log(newUtmParams);
      setUtmParams(newUtmParams);
    };

    captureUtmParams();
    window.addEventListener("popstate", captureUtmParams);

    return () => {
      window.removeEventListener("popstate", captureUtmParams);
    };
  }, [utmContent]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      // Validate phone number first
      if (!phoneNumber) {
        setErrors({ phoneNumber: "Phone number is required" });
        setIsLoading(false);
        return;
      }

      const fullNumber = phoneNumber.startsWith("+")
        ? phoneNumber
        : `+${phoneNumber}`;

      if (!isValidPhoneNumber(fullNumber)) {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
        setIsLoading(false);
        return;
      }

      const formData = {
        firstname,
        lastname,
        businessemail,
        companyName,
        phoneNumber,
        projectdetails,
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmCampaign: utmParams.utm_campaign,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
      };

      // First, save to Appwrite
      await Promise.all([
        databases.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          config.collectionIds.contactForm,
          ID.unique(),
          formData
        ),

        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/submit-form`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }).then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Failed to submit form");
          }
        }),
      ]);

      // Close the modal and show success message
      setIsModalOpen(false);
      setIsSuccessOpen(true);
      resetForm();
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [location]);

  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
  };

  const signupRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === "#signup") {
      signupRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const [isChecked, setIsChecked] = useState(true);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const timerRef = useRef(null);

  const slides = [
    {
      title: "AI Readiness Assessment",
      image: aireadiness,
      description:
        "Most enterprises want AI, only few know how ready they truly are. The AI Readiness Assessment evaluates your organization's digital maturity, capability gaps, and cultural alignment, giving you a clear roadmap for seamless AI assimilation.",
      features: [
        "End-to-end assessment across leadership, departments, and workflows",
        "Instant insights to benchmark digital maturity",
        "Tailored recommendations for implementation and scaling",
      ],
      benefits: [
        "Identify high-impact where you AI journey stands",
        "Minimize risk and accelerate transformation",
        "Build confidence with a data-backed insights",
      ],
    },
    {
      title: "Knowledge Nudge",
      image: knowledgenudge,
      description:
        "Knowledge transfer programs often fade fast. Employees forget most of what they learn within days. Knowledge Nudge keeps learning alive through AI-powered micro-assessments that reinforce knowledge, measure engagement, and improve retention.",
      features: [
        "Instantly converts training material into intelligent quizzes",
        "Tracks performance and learning progress over time",
        "Delivers continuous reinforcement through adaptive nudges",
      ],
      benefits: [
        "Boost long-term knowledge retention",
        "Improve employee performance and engagement",
        "Maximize ROI on learning and development initiatives",
      ],
    },
    {
      title: "Fortune Cookie",
      image: fortunecookie,
      description:
        "Fortune Cookie translates complexity into clarity. It quietly connects with enterprise systems, analyzes data behind the scenes, and delivers precise insights leaders can act on, without the noise of dashboards or technical clutter.",
      features: [
        "Seamless integration with enterprise data environments",
        "AI-driven synthesis that surfaces only what matters most",
        "Predictive insights and alerts that anticipate shifts before they occur",
      ],
      benefits: [
        "Gain executive-level foresight without deep analytics effort",
        "See trends and risks before they're visible in reports",
        "Make confident, timely decisions powered by invisible intelligence",
      ],
    },
    {
      title: "Chateleon",
      image: chateleon,
      description:
        "Chateleon is your website's virtual receptionist. An AI agent that greets visitors, understands intent, and guides them to what they need. It learns from every interaction, personalizes responses, and ensures every visitor feels seen, heard, and helped.",
      features: [
        "Context-aware engagement that adapts to each visitor's journey",
        "Integrates seamlessly with CRMs, support tools, and internal databases",
        "Built for enterprise scalability and multilingual communication",
      ],
      benefits: [
        "Turn every website visit into a meaningful, guided experience",
        "Reduce drop-offs with proactive, personalized assistance",
        "Free up human teams for higher-value conversations",
      ],
    },
  ];

  // Auto-play functionality
  useEffect(() => {
    // Clear any existing timer
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    // Start new timer if not paused
    if (!isPaused) {
      timerRef.current = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % 4);
      }, 3000); // Change slide every 4 seconds
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [isPaused, currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const slides1 = [
    {
      title: "Visual AI",
      image: visualai,
      description:
        "Visual AI helps enterprises transform raw video and image data into real-time, actionable intelligence. From surveillance analytics to quality control, it detects patterns, predicts anomalies, and drives decisions - faster, safer, and smarter.",
      features: [
        "Cloud-Native Integration with existing CCTV and camera infrastructure",
        "Modular, Ready-to-Deploy Architecture tailored for diverse industry needs",
        "Rapid 48-Hour Implementation Pipeline for immediate operational impact",
        "Neural Vector-Based Semantic Search across massive visual datasets",
        "Advanced Multi-Face Detection and Tracking in high-density environments",
        "Edge + Cloud Hybrid Processing for low-latency performance",
      ],
      benefits: [
        "Automate complex visual operations like inspections, monitoring, and compliance",
        "Enhance situational awareness through real-time anomaly and object detection",
        "Reduce manual oversight and improve accuracy across workflows",
        "Enable predictive insights to prevent issues before they occur",
        "Accelerate business intelligence with contextual visual data analytics",
      ],
    },
    {
      title: "Analytical AI",
      image: analytical,
      description:
        "Analytical AI turns big data into business intelligence - explaining what happened, why it happened, what will happen next, and what should be done about it. Built for scale, it fuses descriptive, diagnostic, predictive, and prescriptive analytics into a unified platform that drives confident, data-led decision-making across every function.",
      features: [
        "Unified Big Data Framework that consolidates structured and unstructured sources for seamless analysis",
        "Descriptive and Diagnostic Intelligence to reveal patterns, correlations, and root causes in real time",
        "Predictive and Prescriptive Modeling using advanced ML algorithms to forecast scenarios and recommend optimal actions",
        "Adaptive Dashboards and Interactive Visualization for intuitive, role-based insights",
        "Automated Anomaly Detection that flags deviations and hidden risks instantly",
      ],
      benefits: [
        "Move from hindsight to foresight with predictive and prescriptive intelligence",
        "Accelerate decision velocity across leadership and operational layers",
        "Detect opportunities and vulnerabilities before they impact performance",
        "Empower every department with contextual, data-backed recommendations",
        "Drive measurable ROI through continuous analytics-driven optimization",
      ],
    },
    {
      title: "Textual AI",
      image: textual,
      description:
        "Textual AI transforms unstructured enterprise documents into structured, actionable intelligence. Leveraging advanced Natural Language Processing (NLP) and Retrieval-Augmented Generation (RAG), it extracts knowledge, context, and intent from text at scale - enabling data-rich applications that reason, summarize, and respond with human-like precision.",
      features: [
        "RAG-Enabled Workflows that connect Large Language Models with enterprise knowledge bases for context-aware responses",
        "Intelligent Document Processing (IDP) to analyze, extract, and classify unstructured data from reports, emails, and archives",
        "Automated Summarization and Contextual Querying for quick retrieval of precise, relevant information",
        "Multilingual and Domain-Adaptive Models fine-tuned for enterprise-scale deployments",
      ],
      benefits: [
        "Build enterprise-grade RAG applications that understand and generate insights from vast document repositories",
        "Unlock institutional knowledge trapped in PDFs, reports, and communication threads",
        "Accelerate workflows by automating text-heavy processes across departments",
        "Improve accuracy and compliance through contextual, explainable AI-driven text interpretation",
        "Empower teams to make faster, knowledge-backed decisions",
      ],
    },
    {
      title: "Functional AI",
      image: functional,
      description:
        "Functional AI is where intelligence meets execution. It's designed to automate workflows, optimize processes, and orchestrate smarter operations across every department. From supply chain and HR to finance and customer success, Functional AI learns from performance patterns to enhance productivity and ensure systems run efficiently - with minimal human intervention and maximum reliability.",
      features: [
        "Intelligent process automation and adaptive task routing",
        "AI-based decision support and process optimization",
        "Seamless integration with enterprise applications and APIs",
      ],
      benefits: [
        "Streamline operations through intelligent automation",
        "Improve accuracy, speed, and consistency in execution",
        "Free up human capital for higher-value strategic tasks",
      ],
    },
  ];

  const [currentSlide1, setCurrentSlide1] = useState(0);
  const [isPaused1, setIsPaused1] = useState(false);
  const timerRef1 = useRef(null);

  // Auto-play functionality for second carousel
  useEffect(() => {
    if (timerRef1.current) {
      clearInterval(timerRef1.current);
    }

    if (!isPaused1) {
      timerRef1.current = setInterval(() => {
        setCurrentSlide1((prev) => (prev + 1) % 4);
      }, 3000);
    }

    return () => {
      if (timerRef1.current) {
        clearInterval(timerRef1.current);
      }
    };
  }, [isPaused1, currentSlide1]);

  const nextSlide1 = () => {
    setCurrentSlide1((prev) => (prev + 1) % slides1.length);
  };

  const prevSlide1 = () => {
    setCurrentSlide1((prev) => (prev - 1 + slides1.length) % slides1.length);
  };

  const goToSlide1 = (index) => {
    setCurrentSlide1(index);
  };

  // Add this useEffect to handle hash-based scrolling for specific slides
  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash.toLowerCase();

      // Map of hash values to slide indices
      const hashToSlideMap = {
        "#visualaiplatform": { carousel: 1, slideIndex: 0 },
        "#analyticalai": { carousel: 1, slideIndex: 1 },
        "#textualai": { carousel: 1, slideIndex: 2 },
        "#functionalai": { carousel: 1, slideIndex: 3 },
      };

      const config = hashToSlideMap[hash];

      if (config) {
        // Pause auto-play when navigating via hash
        if (config.carousel === 0) {
          setCurrentSlide(config.slideIndex);
          setIsPaused(true);
        } else if (config.carousel === 1) {
          setCurrentSlide1(config.slideIndex);
          setIsPaused1(true);
        }

        // Scroll to the carousel section
        setTimeout(() => {
          const sectionId =
            config.carousel === 0
              ? "business-enterprise-suite"
              : "ai-ecosystem-section";
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 100);
      }
    };

    handleHashScroll();
    window.addEventListener("hashchange", handleHashScroll);

    return () => {
      window.removeEventListener("hashchange", handleHashScroll);
    };
  }, []);

  return (
    <div className="Main2 cus4:container cus4:mx-auto font-display">
      <div
        className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-16 px-4 mt-10"
        id="enterprise-bi"
      >
        <div className="max-w-6xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1
              className="font-bold text-[#3E59B7] mb-4"
              style={{ fontSize: "40px" }}
            >
              Business Enterprise Suite
            </h1>
            <p
              className="text-[#666666] max-w-4xl mx-auto leading-relaxed"
              style={{ fontSize: "16px" }}
            >
              The Business Enterprise Suite brings together our flagship AI
              platforms - AI Readiness Assessment, Knowledge Nudge, Fortune
              Cookie, and Chateleon. Designed to drive learning, collaboration,
              and strategic decision-making. Together, they form the
              intelligence backbone for organizations ready to lead with AI.
            </p>
          </div>

          {/* Carousel Container */}
          <div
            className="relative"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid md:grid-cols-2 gap-8 items-start p-8 md:p-10">
                {/* Left Content Section - Description and Features */}

                {/* Right Section - Title, Image, and Button */}
                <div className="space-y-6">
                  {/* Title with Icon */}
                  <div className="flex items-center gap-2 bg-[#F1F3FF] border border-[#D6DAF5] rounded-lg px-4 py-2 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
                    <div className="w-5 h-5 flex items-center justify-center border-2 border-[#3E59B7] rounded">
                      <svg
                        className="w-3 h-3 text-[#3E59B7]"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                      >
                        <path d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span
                      className="text-[#3E59B7] font-semibold"
                      style={{ fontSize: "16px" }}
                    >
                      {slides[currentSlide].title}
                    </span>
                  </div>

                  {/* Visual Section */}
                  <div className="border-2 border-gray-200 rounded-lg overflow-hidden bg-custom-gradient10 ">
                    <img
                      src={slides[currentSlide].image}
                      alt={slides[currentSlide].title}
                      className="w-full h-full "
                    />
                  </div>

                  {/* Action Button */}
                  <div className="flex  justify-center">
                    <button
                      className="bg-[#3E59B7] text-white font-semibold px-6 py-2.5 rounded hover:bg-blue-700 transition-colors"
                      style={{ fontSize: "14px" }}
                      onClick={handleButtonClickcontact}
                    >
                      Book a demo
                    </button>
                  </div>
                </div>
                <div className="space-y-6">
                  {/* Description */}
                  <p
                    className="text-gray-600 leading-relaxed"
                    style={{ fontSize: "14px" }}
                  >
                    {slides[currentSlide].description}
                  </p>

                  {/* Key Features */}
                  <div>
                    <h3
                      className="font-bold text-[#3E59B7] mb-3"
                      style={{ fontSize: "16px" }}
                    >
                      Key Features
                    </h3>
                    <div className="space-y-2">
                      {slides[currentSlide].features.map((feature, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-[#3E59B7] rounded-full mt-2 flex-shrink-0"></div>
                          <span
                            className="text-gray-700 leading-relaxed"
                            style={{ fontSize: "14px" }}
                          >
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Business Benefits */}
                  <div>
                    <h3
                      className="font-bold text-[#3E59B7] mb-3"
                      style={{ fontSize: "16px" }}
                    >
                      Business Benefits
                    </h3>
                    <div className="space-y-2">
                      {slides[currentSlide].benefits.map((benefit, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-[#3E59B7] rounded-full mt-2 flex-shrink-0"></div>
                          <span
                            className="text-gray-700 leading-relaxed"
                            style={{ fontSize: "14px" }}
                          >
                            {benefit}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
 <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-300 z-10"          
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-6 h-6 text-[#3E59B7]" />        
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-300 z-10"
            aria-label="Next slide"
          >
            <ChevronRight className="w-6 h-6 text-[#3E59B7]" />
          </button>
            {/* Dot Indicators */}
            <div className="flex justify-center gap-3 mt-8">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`rounded-full transition-all duration-300 ${
                    currentSlide === index
                      ? "bg-blue-600 w-10 h-3"
                      : "bg-gray-300 hover:bg-gray-400 w-3 h-3"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {isPaused && <div className="text-center mt-4"></div>}
          </div>
        </div>
      </div>

      <div
        className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-16 px-4"
        id="ai-ecosystem-section"
      >
        <div className="max-w-6xl mx-auto">
          {/* Header Section */}
          <div className="text-center mb-12">
            <h1
              className="font-bold text-[#3E59B7] mb-4"
              style={{ fontSize: "40px" }}
            >
              Your AI Ecosystem, Evolved
            </h1>
            <p
              className="text-[#666666] max-w-4xl mx-auto leading-relaxed"
              style={{ fontSize: "16px" }}
            >
              Explore our suite of AI platforms engineered for performance,
              scalability, and trust. From enterprise automation to adaptive
              analytics, every platform is built to solve real-world challenges
              with precision and ingenuity.
            </p>
          </div>

          {/* Carousel Container */}
          <div
            className="relative"
            onMouseEnter={() => setIsPaused1(true)}
            onMouseLeave={() => setIsPaused1(false)}
          >
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid md:grid-cols-2 gap-8 items-start p-8 md:p-10">
                {/* Left Content Section */}
                <div className="space-y-6">
                  {/* Title with Icon */}
                  <div className="flex items-center gap-2 bg-[#F1F3FF] border border-[#D6DAF5] rounded-lg px-4 py-2 shadow-sm hover:shadow-md transition-all duration-300 cursor-pointer">
                    <div className="w-5 h-5 flex items-center justify-center border-2 border-[#3E59B7] rounded">
                      <svg
                        className="w-3 h-3 text-[#3E59B7]"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                      >
                        <path d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span
                      className="text-[#3E59B7] font-semibold"
                      style={{ fontSize: "16px" }}
                    >
                      {slides1[currentSlide1].title}
                    </span>
                  </div>

                  {/* Description */}
                  <p
                    className="text-gray-600 leading-relaxed"
                    style={{ fontSize: "14px" }}
                  >
                    {slides1[currentSlide1].description}
                  </p>

                  {/* Key Features */}
                  <div>
                    <h3
                      className="font-bold text-[#3E59B7] mb-3"
                      style={{ fontSize: "16px" }}
                    >
                      Key Features
                    </h3>
                    <div className="space-y-2">
                      {slides1[currentSlide1].features.map((feature, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-[#3E59B7] rounded-full mt-2 flex-shrink-0"></div>
                          <span
                            className="text-gray-700 leading-relaxed"
                            style={{ fontSize: "14px" }}
                          >
                            {feature}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Business Benefits */}
                  <div>
                    <h3
                      className="font-bold text-[#3E59B7] mb-3"
                      style={{ fontSize: "16px" }}
                    >
                      Business Benefits
                    </h3>
                    <div className="space-y-2">
                      {slides1[currentSlide1].benefits.map((benefit, idx) => (
                        <div key={idx} className="flex items-start gap-2">
                          <div className="w-1.5 h-1.5 bg-[#3E59B7] rounded-full mt-2 flex-shrink-0"></div>
                          <span
                            className="text-gray-700 leading-relaxed"
                            style={{ fontSize: "14px" }}
                          >
                            {benefit}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex flex-wrap gap-3 pt-2">
                    <button
                      className="bg-[#3E59B7] text-white font-semibold px-6 py-2.5 rounded hover:bg-blue-700 transition-colors"
                      style={{ fontSize: "14px" }}
                      onClick={handleButtonClickcontact}
                    >
                      Book a demo
                    </button>
                  </div>
                </div>

                {/* Right Visual Section */}
                <div className="border-2 border-gray-200 rounded-lg overflow-hidden bg-gray-50 h-full object-contain">
                  <img
                    src={slides1[currentSlide1].image}
                    alt={slides1[currentSlide1].title}
                    className="w-full h-full object-contains"
                  />
                </div>
              </div>
            </div>
 <button
            onClick={prevSlide1}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-300 z-10"          
            aria-label="Previous slide"
          >
            <ChevronLeft className="w-6 h-6 text-[#3E59B7]" />        
          </button>
          <button
            onClick={nextSlide1}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-all duration-300 z-10"
            aria-label="Next slide"
          >
            <ChevronRight className="w-6 h-6 text-[#3E59B7]" />
          </button>
            {/* Dot Indicators */}
            <div className="flex justify-center gap-3 mt-8">
              {slides1.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide1(index)}
                  className={`rounded-full transition-all duration-300 ${
                    currentSlide1 === index
                      ? "bg-blue-600 w-10 h-3"
                      : "bg-gray-300 hover:bg-gray-400 w-3 h-3"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {isPaused1 && <div className="text-center mt-4"></div>}
          </div>
        </div>
      </div>

      <section
        className="text-[#666666] min-h-[180px] md:min-h-[230px] relative mt-20 bg-no-repeat bg-cover"
        style={{
          background: "linear-gradient(100deg , #3E59B7 90%, #A6BAFF 110%)",
        }}
      >
        <figure className="absolute bottom-0 right-0">
          <img
            src={recright}
            alt="Additional"
            loading="lazy"
            className="lg:w-40 lg:h-auto w-24 h-36 md:w-40 md:h-full"
          />
        </figure>

        <article className="absolute inset-0 flex flex-col justify-center items-center text-center text-white pt-4 md:pt-10 md:mr-32 lg:pt-5 md:ml-20">
          <h2 className="font-bold mb-4 font-display text-[16px] md:text-[20px] lg:text-[24px]">
            Ready to Experience Our AI Platforms?
          </h2>

          <p className="font-light mb-4 font-display mx-2 text-[12px] md:text-[13px] lg:text-[16px]">
            Discover how our comprehensive AI platform suite can transform your
            <br />
            enterprise operations and drive unprecedented growth.
          </p>

          <div className="flex gap-4">
            <button
              className="md:mt-3 mb-3 rounded-xl border text-[#3E59B7] bg-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out hover:bg-transparent hover:border hover:border-white hover:text-[#FFFFFF]"
              onClick={handleButtonClickcontact}
            >
              <div className="flex items-center">
                <span className="font-bold text-[12px] md:text-[16px]">
                  Start Free Trial
                </span>
              </div>
            </button>

            <button
              className="md:mt-3 mb-3 rounded-xl border text-white border-white md:py-3 md:px-20 px-8 py-2 transition-all duration-300 ease-in-out bg-transparent hover:bg-white hover:text-[#3E59B7]"
              onClick={handleButtonClickcontact}
            >
              <div className="flex items-center">
                <span className="font-bold text-[12px] md:text-[16px]">
                  Schedule Demo
                </span>
              </div>
            </button>
          </div>
        </article>
      </section>

      {isModalOpen && (
        <section className="fixed z-50 inset-0 md:p-0 lg:px-20 p-12  bg-[rgba(0,0,0,0.5)] flex items-center justify-center">
          <div className="relative bg-[#F1F6FF]   p-8 lg:px-10 rounded-lg max-h-screen   max-w-md w-full">
            <a
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeModal}
            >
              <svg
                className="lg:w-6 lg:h-6 w-4 h-4 cursor-pointer"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </a>
            {/* <div className='text-lg md:text-xl text-center font-bold mb-4'>
                  Experience the Power of Data <br />
                  With
                  <span className='text-[#C62B6D] font-bold'> AI Fortune </span>
                  Cookie
                </div> */}
            <form onSubmit={handleSubmit}>
              <div className="max-h-[400px] overflow-y-auto custom-scrollbar pr-4 ">
                <div className="mb-2">
                  <label className=" text-gray-700">First Name</label>
                  <input
                    id="firstname"
                    type="text"
                    name="firstname"
                    value={firstname}
                    onChange={(e) => setfirstname(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.firstname && (
                    <p className="text-red-500 text-sm">{errors.firstname}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label className=" text-gray-700">Last Name</label>
                  <input
                    type="text"
                    name="lastname"
                    id="lastname3"
                    value={lastname}
                    onChange={(e) => setlastname(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.lastname && (
                    <p className="text-red-500 text-sm">{errors.lastname}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label id="Phonenumber" className=" text-gray-700">
                    Phone Number
                  </label>
                  <PhoneInput
                    country={"in"}
                    value={phoneNumber}
                    onChange={(number, country) =>
                      handlePhoneNumberChange(number, country)
                    }
                    inputClass="custom-phone-input2 "
                    buttonClass="border rounded"
                    dropdownClass="border rounded"
                    required
                    enableSearch={true}
                    inputProps={{
                      required: true,
                      autoFocus: false,
                    }}
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label className="text-gray-700">Company Name</label>
                  <input
                    id="Companyname"
                    type="text"
                    name="companyName"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>
                <div className="mb-2">
                  <label className=" text-gray-700">Business Email</label>
                  <input
                    id="businessemail"
                    type="email"
                    name="businessemail"
                    value={businessemail}
                    onChange={(e) => setEmailId(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.businessemail && (
                    <p className="text-red-500 text-sm">
                      {errors.businessemail}
                    </p>
                  )}
                </div>

                <div className="mb-4">
                  <label className=" text-gray-700">
                    Project Details(Optional)
                  </label>
                  <input
                    id="projectdetails"
                    type="text"
                    name="projectdetails"
                    value={projectdetails}
                    onChange={(e) => setprojectdetails(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>
                <div className="disclaimerContainercontact">
                  <label className="checkboxLabel">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      className="checkbox"
                    />
                    <span className="checkboxText">
                      I agree and authorize team to contact me and/or send
                      relevant information over Email, SMS & WhatsApp. This will
                      override the registry with DNC/NDNC.
                    </span>
                  </label>
                </div>
                {errors.terms && (
                  <p className="text-red-500 text-sm">{errors.terms}</p>
                )}
                <div className="linksContainer">
                  <a href="/terms-of-service/" className="link">
                    Terms of Service
                  </a>
                  <a href="/privacy-policy/" className="link">
                    Privacy Policy
                  </a>
                </div>
              </div>
              <div className="mb-4">
                <button
                  id="submit"
                  type="submit"
                  className={`w-full px-4 py-2 bg-[#C62B6D] text-white rounded ${
                    !isChecked || isLoading
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={!isChecked || isLoading}
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      <span>Submitting...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </section>
      )}
      {isSuccessOpen && (
        <section className="fixed inset-0 z-50 bg-[rgba(0,0,0,0.5)] flex items-center justify-center">
          <div className="relative bg-white p-8 rounded-lg max-w-md w-full text-center">
            <a
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeSuccessModal}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </a>
            <h2 className="text-2xl font-bold mb-4">Success!</h2>
            <p className="mb-4">Your request has been sent successfully.</p>
            <button
              id="close"
              className="px-4 py-2 bg-[#C62B6D] text-white rounded"
              onClick={closeSuccessModal}
            >
              Close
            </button>
          </div>
        </section>
      )}
    </div>
  );
};

export default Platform;
